// The image stays up until the chat's first reply (carried into the chat page),
// never shorter than SCENARIO_MIN_MS and never longer than SCENARIO_MAX_MS from
// when it first showed. Don chose this over a fixed 3 s hold (LAN-1245).
export const SCENARIO_MIN_MS = 1500;
export const SCENARIO_MAX_MS = 10000;
export const scenarioKey = chatId => `my-path:scenario:${chatId}`;

export function storeScenario(chatId, scenario) {
  try {
    sessionStorage.setItem(scenarioKey(chatId), JSON.stringify({ ...scenario, chatId }));
  } catch (_) { /* Storage may be disabled; starting the chat must still work. */ }
}

export function mountScenarioScreen(data, onClose) {
  const previous = document.activeElement;
  const screen = document.createElement('button');
  screen.type = 'button';
  screen.className = 'mp-scenario-screen';
  screen.setAttribute('aria-label', `${data.title}. ${data.dismissHint}`);
  const add = (tag, className, text, parent = screen) => {
    const element = document.createElement(tag);
    element.className = className;
    if (text) element.textContent = text;
    parent.appendChild(element);
    return element;
  };
  const image = (url, className, parent) => {
    const img = add('img', className, null, parent);
    img.alt = '';
    img.src = url;
    return img;
  };
  image(data.thumbnailUrl || data.imageUrl, 'mp-scenario-backdrop');
  const content = add('span', 'mp-scenario-content');
  const frame = add('span', 'mp-scenario-frame', null, content);
  if (data.thumbnailUrl) image(data.thumbnailUrl, 'mp-scenario-thumbnail', frame);
  const art = image(data.imageUrl, 'mp-scenario-art', frame);
  art.addEventListener('error', () => { art.hidden = true; });
  add('span', 'mp-scenario-title', data.title, content);
  add('span', 'mp-scenario-category', data.categoryLabel, content);
  const dots = add('span', 'mp-scenario-dots', null, content);
  dots.setAttribute('aria-hidden', 'true');
  for (let i = 0; i < 3; i++) add('span', '', null, dots);
  add('span', 'mp-scenario-hint', data.dismissHint, content);
  const keydown = event => {
    if (event.key === 'Escape') { event.preventDefault(); onClose(); }
  };
  screen.addEventListener('click', onClose);
  document.addEventListener('keydown', keydown);
  document.body.appendChild(screen);
  screen.focus();
  const timer = setTimeout(onClose, Math.max(0, SCENARIO_MAX_MS - (Date.now() - data.shownAt)));
  return {
    screen,
    remove() {
      clearTimeout(timer);
      document.removeEventListener('keydown', keydown);
      screen.remove();
      if (previous?.isConnected) previous.focus();
    },
  };
}
